module.exports = __webpack_public_path__ + "90becaaf59494af67908aac65d38844e.svg";